// Конфигурация ЮKassa
// ВАЖНО: Shop ID и Secret Key используются только на backend

// Определяем базовый URL для API
// Для localhost: относительный путь (проксируется через setupProxy.js)
// Для продакшена: абсолютный URL
const getApiBaseUrl = () => {
  // В браузере проверяем hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'annavision.me' || hostname === 'www.annavision.me') {
      return 'https://annavision.me';
    }
  }
  // Для localhost и других окружений - относительный путь
  return '';
};

const API_BASE_URL = getApiBaseUrl();

export const YOOKASSA_CONFIG = {
  AMOUNT: 21739.00,
  CURRENCY: 'RUB',
  DESCRIPTION: 'Персональный прогноз по 9 Дворцам на 2026 год',
  // URL для перенаправления после оплаты
  RETURN_URL: 'https://annavision.me/9palaces/thank-you',
  // API endpoint для создания платежа - ВСЕГДА с префиксом /api/
  // ВАЖНО: Путь должен начинаться с /api/, иначе будет 404
  // Для localhost: относительный путь /api/yookassa/create-payment (проксируется через setupProxy.js)
  // Для продакшена: https://annavision.me/api/yookassa/create-payment
  CREATE_PAYMENT_API: `${API_BASE_URL}/api/yookassa/create-payment`,
  // API endpoint для проверки статуса платежа
  VERIFY_PAYMENT_API: `${API_BASE_URL}/api/yookassa/verify-payment`,
};

// Детальное логирование для отладки
if (typeof window !== 'undefined') {
  console.log('=== YOOKASSA CONFIG DEBUG ===');
  console.log('window.location.hostname:', window.location.hostname);
  console.log('API_BASE_URL:', API_BASE_URL);
  console.log('CREATE_PAYMENT_API:', YOOKASSA_CONFIG.CREATE_PAYMENT_API);
  console.log('===========================');
}

// Детали исполнителя (те же, что и для Робокассы)
export const EXECUTOR_DETAILS = {
  FULL_NAME: 'Калмыкова Анна Александровна',
  INN: '745109437025',
  LEGAL_STATUS: 'самозанятая (налоговый режим — НПД)',
  EMAIL: 'keys@annavision.me',
  WEBSITE: 'www.annavision.me',
  OFFER_URL: 'https://annavision.me/9palaces/oferta/',
};
